import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _createClass from '@babel/runtime/helpers/createClass';
import _classCallCheck from '@babel/runtime/helpers/classCallCheck';
import _assertThisInitialized from '@babel/runtime/helpers/assertThisInitialized';
import _inherits from '@babel/runtime/helpers/inherits';
import _possibleConstructorReturn from '@babel/runtime/helpers/possibleConstructorReturn';
import _getPrototypeOf from '@babel/runtime/helpers/getPrototypeOf';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import React__default, { Component } from 'react';
import styled, { keyframes } from 'styled-components';
import '../../App.css.js';
var _excluded = ["style", "color", "isMobile", "className", "scrollRefPage", "scrollScaleParallaxIn", "scrollScaleParallaxOut", "fadeIn", "fadeOut", "parallaxOut", "parallaxIn", "offsetParallaxOut", "offsetParallaxIn", "fadeInDuration", "fadeInDelay", "fadeOutDistance", "fadeInFillMode", "fadeInDistance", "fadeInOffset", "fadeInTiming", "fadeInOnlyOpacity", "fadeInOnlyMovement", "fadeOutDuration", "fadeOutDelay", "fadeOutFillMode", "fadeOutOnlyOpacity", "fadeOutOnlyMovement", "fadeOutTiming", "fadeOutOffset", "autoPlay"];
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var width = typeof window != "undefined" ? window.innerWidth : 0,
  height = typeof window != "undefined" ? window.innerHeight : 0;
var defaultFadeIn = function defaultFadeIn(y) {
  return keyframes(["0%{transform:translateY(", ");opacity:0;}100%{transform:translateY(0px);opacity:1;}"], y ? y : "200px");
};
var defaultFadeOut = function defaultFadeOut(y) {
  return keyframes(["0%{transform:translateY(0px);opacity:1;}100%{transform:translateY(", ");opacity:0;}"], y ? y : "-200px");
};
var defaultMovementIn = function defaultMovementIn(y) {
  return keyframes(["0%{transform:translateY(", ");}100%{transform:translateY(0px);}"], y ? y : "200px");
};
var defaultMovementOut = function defaultMovementOut(y) {
  return keyframes(["0%{transform:translateY(0px);}100%{transform:translateY(", ");}"], y ? y : "-200px");
};
var AnimationDiv = styled.div.withConfig({
  displayName: "animation-wrappercomponent__AnimationDiv",
  componentId: "sc-dheiad-0"
})(["opacity:", ";transition:transform 0.1s;will-change:transform,opacity;@keyframes defaultOpacityIn{from{opacity:0;}to{opacity:1;}}@keyframes defaultOpacityOut{from{opacity:1;}to{opacity:0;}}&.fade-in{animation-name:", ";animation-duration:", ";animation-delay:", ";animation-timing-function:", ";animation-fill-mode:", ";}&.fade-out{animation-name:", ";animation-duration:", ";animation-delay:", ";animation-timing-function:", ";animation-fill-mode:", ";}"], function (props) {
  return props.fadeIn && !props.fadeInOnlyMovement ? 0 : 1;
}, function (props) {
  return props.fadeInOnlyOpacity ? "defaultOpacityIn" : props.fadeInOnlyMovement ? defaultMovementIn(props.fadeInDistance) : defaultFadeIn(props.fadeInDistance);
}, function (props) {
  return props.fadeInDuration ? props.fadeInDuration : "1s";
}, function (props) {
  return props.fadeInDelay ? props.fadeInDelay : "0s";
}, function (props) {
  return props.fadeInTiming ? props.fadeInTiming : "ease";
}, function (props) {
  return props.fadeInFillMode ? props.fadeInFillMode : "forwards";
}, function (props) {
  return props.fadeOutOnlyOpacity ? "defaultOpacityOut" : props.fadeOutOnlyMovement ? defaultMovementOut(props.fadeOutDistance) : defaultFadeOut(props.fadeInDistance);
}, function (props) {
  return props.fadeOutDuration ? props.fadeOutDuration : "1s";
}, function (props) {
  return props.fadeOutDelay ? props.fadeOutDelay : "0s";
}, function (props) {
  return props.fadeOutTiming ? props.fadeOutTiming : "ease";
}, function (props) {
  return props.fadeOutFillMode ? props.fadeOutFillMode : "forwards";
});
var DEFAULT_SCROLL_SCALE = 0.3;
var AnimationWrapper = /*#__PURE__*/function (_Component) {
  _inherits(AnimationWrapper, _Component);
  var _super = _createSuper(AnimationWrapper);
  function AnimationWrapper(props) {
    var _this;
    _classCallCheck(this, AnimationWrapper);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "elementInTopViewport", function (el) {
      var _this$props = _this.props,
        scrollRefPage = _this$props.scrollRefPage,
        scrollScaleParallaxOut = _this$props.scrollScaleParallaxOut;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var enableAnimation = rect.bottom <= (scrollRefPage ? vHeight * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE) : (rect.bottom - rect.top) * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE)) && rect.bottom >= 0; //console.log("top: " + rect.top + " - left: " + rect.left + " - right: " + rect.right + " - bottom: " + rect.bottom);
      // Return true if any of its four corners are visible

      return (
        //!el.contains(efp(rect.left, rect.bottom)) &&
        //!el.contains(efp(rect.right, rect.bottom)) &&
        enableAnimation
      );
    });
    _defineProperty(_assertThisInitialized(_this), "startFadeOut", function (el) {
      var _this$props2 = _this.props;
      _this$props2.scrollRefPage;
      _this$props2.scrollScaleParallaxOut;
      if (!el) return;
      var rect = el.getBoundingClientRect();
      typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var enableAnimation = rect.bottom <= rect.bottom - rect.top && rect.bottom >= 0; //console.log("top: " + rect.top + " - left: " + rect.left + " - right: " + rect.right + " - bottom: " + rect.bottom);
      // Return true if any of its four corners are visible

      return (
        //!el.contains(efp(rect.left, rect.bottom)) &&
        //!el.contains(efp(rect.right, rect.bottom)) &&
        enableAnimation
      );
    });
    _defineProperty(_assertThisInitialized(_this), "elementInBottomViewport", function (el) {
      var _this$props3 = _this.props,
        scrollRefPage = _this$props3.scrollRefPage,
        scrollScaleParallaxIn = _this$props3.scrollScaleParallaxIn;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var enableAnimation = rect.top >= (scrollRefPage ? vHeight - vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE) : vHeight - (rect.bottom - rect.top) * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) && rect.top <= vHeight;
      /*if(enableAnimation) {
        console.log(
          "top: " + rect.top + " - annimation space: " + (vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) + " - height - animation space" + (vHeight - vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) + " - heightpage: " + vHeight
        );
      }*/
      // Return true if any of its four corners are visible

      return enableAnimation;
    });
    _defineProperty(_assertThisInitialized(_this), "startFadeIn", function (el) {
      var _this$props4 = _this.props;
      _this$props4.scrollRefPage;
      _this$props4.scrollScaleParallaxIn;
      var fadeInOffset = _this$props4.fadeInOffset;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var enableAnimation = rect.top >= vHeight - (rect.bottom - rect.top + (fadeInOffset || 0)) && rect.top <= vHeight - (fadeInOffset || 0);
      /*if(enableAnimation) {
        console.log(
          "top: " + rect.top + " - annimation space: " + (vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) + " - height - animation space" + (vHeight - vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) + " - heightpage: " + vHeight
        );
      }*/
      // Return true if any of its four corners are visible

      return enableAnimation;
    });
    _defineProperty(_assertThisInitialized(_this), "elementInCenterViewport", function (el) {
      var _this$props5 = _this.props,
        scrollRefPage = _this$props5.scrollRefPage,
        parallaxIn = _this$props5.parallaxIn,
        parallaxOut = _this$props5.parallaxOut,
        scrollScaleParallaxIn = _this$props5.scrollScaleParallaxIn,
        scrollScaleParallaxOut = _this$props5.scrollScaleParallaxOut;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var enableParallaxIn = rect.top < (scrollRefPage ? vHeight - vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE) : vHeight - (rect.bottom - rect.top) * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) && parallaxIn && rect.bottom >= 0;
      var enableParallaxOut = rect.bottom > (scrollRefPage ? vHeight * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE) : vHeight - (rect.bottom - rect.top) * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE)) && parallaxOut && rect.top <= vHeight;
      return enableParallaxIn && !parallaxOut || enableParallaxOut && !parallaxIn || enableParallaxIn && enableParallaxOut;
    });
    _defineProperty(_assertThisInitialized(_this), "elementInCenterForFadeInViewport", function (el) {
      var fadeInOffset = _this.props.fadeInOffset;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      // Return false if it's not in the viewport

      if (rect.bottom > 0 && rect.bottom < vHeight - (fadeInOffset || 0)) {
        return true;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "getTranslateYParallaxOut", function (el) {
      var _this$props6 = _this.props,
        offsetParallaxOut = _this$props6.offsetParallaxOut,
        scrollRefPage = _this$props6.scrollRefPage,
        scrollScaleParallaxOut = _this$props6.scrollScaleParallaxOut;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var MAX = scrollRefPage ? -vHeight : rect.bottom - rect.top;
      /*let MOVEMENT =
        (scrollRefPage
          ? -vHeight * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE)
          : MAX * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE)) -
        (offsetParallaxOut || 0);*/

      var MOVEMENT = (scrollRefPage ? -vHeight * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE) : MAX * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE)) + (offsetParallaxOut || 0); //let translateY = (MOVEMENT * rect.top) / MAX;

      var translateY = MOVEMENT * (scrollRefPage ? vHeight * (scrollScaleParallaxOut || DEFAULT_SCROLL_SCALE) - rect.bottom : -rect.top) / MAX;
      return (
        //!el.contains(efp(rect.left, rect.bottom)) &&
        //!el.contains(efp(rect.right, rect.bottom)) &&
        "translateY(-" + translateY + "px)"
      );
    });
    _defineProperty(_assertThisInitialized(_this), "getTranslateYParallaxIn", function (el) {
      var _this$props7 = _this.props,
        offsetParallaxIn = _this$props7.offsetParallaxIn,
        scrollRefPage = _this$props7.scrollRefPage,
        scrollScaleParallaxIn = _this$props7.scrollScaleParallaxIn;
      if (!el) return;
      var rect = el.getBoundingClientRect(),
        vHeight = typeof window != "undefined" ? window.innerHeight || document.documentElement.clientHeight : 0;
      var MAX = scrollRefPage ? vHeight : rect.bottom - rect.top;
      var MOVEMENT = (scrollRefPage ? vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE) : MAX * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) + (offsetParallaxIn || 0);
      var translateY = MOVEMENT * (scrollRefPage ? rect.top - (vHeight - vHeight * (scrollScaleParallaxIn || DEFAULT_SCROLL_SCALE)) : rect.bottom - vHeight) / MAX;
      /*console.log(
        "PARALLAX IN ------ " +
          MOVEMENT +
          " - " +
          MAX +
          " - " +
          translateY +
          " - " +
          rect.bottom +
          " - " +
          vHeight
      );*/
      //console.log(MOVEMENT + " - " + MAX + " - " + rect.top + " - " + vHeight);

      return (
        //!el.contains(efp(rect.left, rect.bottom)) &&
        //!el.contains(efp(rect.right, rect.bottom)) &&
        "translateY(" + translateY + "px)"
      );
    });
    _defineProperty(_assertThisInitialized(_this), "handleAnimationsOnResize", function () {
      if (typeof window != "undefined" && (window.innerWidth != width || Math.abs(window.innerHeight - height) > 100)) {
        width = window.innerWidth;
        height = window.innerHeight;
        _this.handleAnimations();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "handleAnimations", function () {
      var _this$props8 = _this.props,
        parallaxIn = _this$props8.parallaxIn,
        parallaxOut = _this$props8.parallaxOut;
      _this$props8.scrollRefPage;
      _this.checkFadeIn();
      _this.checkFadeOut();
      _this.checkParallaxIn();
      _this.checkParallaxOut();
      if (_this.elementInCenterViewport(_this.animationRef.current) && (parallaxIn || parallaxOut)) {
        _this.animationRef.current.style.transform = "translateY(0px)";
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkFadeIn", function () {
      var fadeIn = _this.props.fadeIn;
      if ((_this.startFadeIn(_this.animationRef.current) || _this.elementInCenterForFadeInViewport(_this.animationRef.current)) && fadeIn && _this.animationRef.current.className.lastIndexOf("fade-in") < 0) {
        _this.animationRef.current.className += " fade-in";
        if (_this.animationRef.current.className.lastIndexOf("fade-out") >= 0) {
          _this.animationRef.current.classList.toggle("fade-out");
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkFadeOut", function () {
      var fadeOut = _this.props.fadeOut;
      if (_this.startFadeOut(_this.animationRef.current) && fadeOut && _this.animationRef.current.className.lastIndexOf("fade-out") < 0) {
        _this.animationRef.current.className += " fade-out";
        if (_this.animationRef.current.className.lastIndexOf("fade-in") >= 0) {
          _this.animationRef.current.classList.toggle("fade-in");
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "checkParallaxIn", function () {
      var parallaxIn = _this.props.parallaxIn;
      if (_this.elementInBottomViewport(_this.animationRef.current) && parallaxIn) {
        _this.animationRef.current.style.transform = _this.getTranslateYParallaxIn(_this.animationRef.current); //console.log("lol");
      }
    });

    _defineProperty(_assertThisInitialized(_this), "checkParallaxOut", function () {
      var parallaxOut = _this.props.parallaxOut;
      if (_this.elementInTopViewport(_this.animationRef.current) && parallaxOut) {
        _this.animationRef.current.style.transform = _this.getTranslateYParallaxOut(_this.animationRef.current);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      if (_this.props.scrollElement && _this.props.scrollElement != null) {
        _this.props.scrollElement.addEventListener("scroll", _this.handleAnimations, {
          passive: true
        });
      }
      if (typeof window != "undefined") {
        window.addEventListener("resize", _this.handleAnimationsOnResize, {
          passive: true
        });
      }
      if (_this.props.autoPlay) {
        _this.animationRef.current.className += " fade-in";
        if (_this.animationRef.current.className.lastIndexOf("fade-out") >= 0) {
          _this.animationRef.current.classList.toggle("fade-out");
        }
      } else {
        _this.handleAnimations();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "render", function () {
      var _this$props9 = _this.props,
        style = _this$props9.style;
      _this$props9.color;
      _this$props9.isMobile;
      var className = _this$props9.className,
        scrollRefPage = _this$props9.scrollRefPage,
        scrollScaleParallaxIn = _this$props9.scrollScaleParallaxIn,
        scrollScaleParallaxOut = _this$props9.scrollScaleParallaxOut,
        fadeIn = _this$props9.fadeIn,
        fadeOut = _this$props9.fadeOut,
        parallaxOut = _this$props9.parallaxOut,
        parallaxIn = _this$props9.parallaxIn,
        offsetParallaxOut = _this$props9.offsetParallaxOut,
        offsetParallaxIn = _this$props9.offsetParallaxIn,
        fadeInDuration = _this$props9.fadeInDuration,
        fadeInDelay = _this$props9.fadeInDelay,
        fadeOutDistance = _this$props9.fadeOutDistance,
        fadeInFillMode = _this$props9.fadeInFillMode,
        fadeInDistance = _this$props9.fadeInDistance;
      _this$props9.fadeInOffset;
      var fadeInTiming = _this$props9.fadeInTiming,
        fadeInOnlyOpacity = _this$props9.fadeInOnlyOpacity,
        fadeInOnlyMovement = _this$props9.fadeInOnlyMovement,
        fadeOutDuration = _this$props9.fadeOutDuration,
        fadeOutDelay = _this$props9.fadeOutDelay,
        fadeOutFillMode = _this$props9.fadeOutFillMode,
        fadeOutOnlyOpacity = _this$props9.fadeOutOnlyOpacity,
        fadeOutOnlyMovement = _this$props9.fadeOutOnlyMovement,
        fadeOutTiming = _this$props9.fadeOutTiming;
      _this$props9.fadeOutOffset;
      var autoPlay = _this$props9.autoPlay,
        rest = _objectWithoutProperties(_this$props9, _excluded);
      return /*#__PURE__*/React__default.createElement(AnimationDiv, {
        className: className,
        scrollRefPage: scrollRefPage,
        scrollScaleParallaxIn: scrollScaleParallaxIn,
        scrollScaleParallaxOut: scrollScaleParallaxOut,
        fadeIn: fadeIn,
        fadeOut: fadeOut,
        parallaxIn: parallaxIn,
        parallaxOut: parallaxOut,
        offsetParallaxIn: offsetParallaxIn,
        offsetParallaxOut: offsetParallaxOut,
        fadeInDuration: fadeInDuration,
        fadeInDelay: fadeInDelay,
        fadeInFillMode: fadeInFillMode,
        fadeInTiming: fadeInTiming,
        fadeInOnlyOpacity: fadeInOnlyOpacity,
        fadeInOnlyMovement: fadeInOnlyMovement,
        fadeOutDuration: fadeOutDuration,
        fadeOutTiming: fadeOutTiming,
        fadeOutDistance: fadeOutDistance,
        fadeInDistance: fadeInDistance,
        fadeOutDelay: fadeOutDelay,
        fadeOutFillMode: fadeOutFillMode,
        fadeOutOnlyOpacity: fadeOutOnlyOpacity,
        fadeOutOnlyMovement: fadeOutOnlyMovement,
        ref: _this.animationRef,
        autoPlay: autoPlay,
        style: _objectSpread({}, style)
      }, rest.children);
    });
    _this.divRef = /*#__PURE__*/React__default.createRef();
    _this.main = /*#__PURE__*/React__default.createRef();
    _this.cards = /*#__PURE__*/React__default.createRef();
    _this.animationRef = /*#__PURE__*/React__default.createRef();
    _this.state = {
      animationStopped: true
    };
    return _this;
  }
  return _createClass(AnimationWrapper);
}(Component);
export { AnimationWrapper as default };